import {
  Navbar,
  Container,
  Nav,
  Offcanvas,
  Badge,
  OverlayTrigger,
  Tooltip,
  Accordion,
  Dropdown,
} from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Header.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Form } from "react-bootstrap";
import {
  faBagShopping,
  faDollarSign,
  faHeart,
  faMagnifyingGlass,
  faMoneyBill,
  faShoppingCart,
  faUser,
  faWallet,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import Green_btn from "../common-components/common_btn/green_btn/Green_btn";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Login_Modal from "../common-components/common_modal/login_modal/Login_Modal";
import Reset_Password_Modal from "../common-components/common_modal/reset_password_modal/Reset_Password_Modal";
import Set_New_Password_Modal from "../common-components/common_modal/set_new_password_modal/Set_New_Password_Modal";
import Success_Modal from "../common-components/common_modal/success_modal/Success_Modal";
import Cancel_Reason_Modal from "../common-components/common_modal/cancel_reason_modal/Cancel_Reason_Modal";
import OrderTrackModal from "../common-components/common_modal/order_track_modal/OrderTrackModal";
import { useDispatch, useSelector } from "react-redux";
import { myAccount } from "../../features/my_account/Slice";
import Cookies from "js-cookie";
import { getAllCart, postToLoginCart } from "../../features/cart/cartSlice";
import { getAllWishlist } from "../../features/wishlist/wishlistSlice";
import ListGroup from "react-bootstrap/ListGroup";
import {
  allCurrency,
  appSetup,
  ExchangeRate,
  getAllCategories,
  getAllChildCategory,
  getAllSubCategory,
  setCurrentCurrency,
} from "../../features/master/masterSlice";
import {
  getAllProducts,
  searchProducts,
  getHeaderProducts,
} from "../../features/products/productsSlice";
import { getHomeHeaders } from "../../features/home/homeSlice";

function Header() {
  const location = useLocation();

  // Reusable Tooltip Renderer with dynamic label
  const renderTooltip = (label) => (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {label}
    </Tooltip>
  );
  const [showSearch, setShowSearch] = useState(false);
  const [showResetModal, setShowResetModal] = useState(false);
  const [showSetPassModal, setShowSetPassModal] = useState(false);
  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const [showAccountCreted, setShowAccountCreted] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const currentPath = location.pathname;
  const searchRef = useRef(null); // ✅ Ref for detecting outside click

  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showSearchResult, setShowSearchResult] = useState(false);

  const closeSearchModal = () => {
    setShowSearch(false);
    setShowSearchResult(false);
    setSearchResults([]);
    setSearchTerm("");
  };

  useEffect(() => {
    closeSearchModal();
  }, [location.pathname]);

  const dispatch = useDispatch();

  const sociallink = useSelector((state) => state.master.social_link);

  const searchProductsData = useSelector(
    (state) => state.product.searchProducts,
  );

  const headerData = useSelector((state) => state.home.headers);

  useEffect(() => {
    dispatch(getHomeHeaders());
  }, [dispatch]);

  //search use effect
  useEffect(() => {
    if (searchTerm.trim()) {
      dispatch(
        searchProducts({
          name: searchTerm,
        }),
      );
    } else {
      setSearchResults([]);
      setShowSearchResult(false);
    }
  }, [dispatch, searchTerm]);

  //search use effect
  useEffect(() => {
    if (searchTerm.trim() === "") {
      setSearchResults([]);
      setShowSearchResult(false);
      return;
    }

    setSearchResults(searchProductsData?.products || []);
    setShowSearchResult(true);
  }, [searchProductsData, searchTerm]);

  const handleClose = () => setShowOffcanvas(false);
  const handleShow = () => setShowOffcanvas(true);

  const user = useSelector((state) => state.myaccount.addMyaccount);

  // useEffect(() => {
  //   dispatch(myAccount());
  // }, [dispatch]);
  const isSignin = useSelector((state) => state.auth.is_signin);
  const currentCurrency = useSelector((state) => state.master.currentCurrency);
  const currency = useSelector((state) => state.master.all_currency);
  useEffect(() => {
    dispatch(allCurrency());
  }, [dispatch]);

  useEffect(() => {
    if (currency.length && !currentCurrency) {
      dispatch(setCurrentCurrency(currency[0]));
    }
  }, [currency, currentCurrency, dispatch]);

  const allcartData = useSelector((state) => state.cart.allCarts);
  useEffect(() => {
    dispatch(getAllCart(isSignin));
  }, [dispatch]);

  const allWishlist = useSelector((state) => state.wishlist.allWishlist);
  // useEffect(() => {
  //   dispatch(getAllWishlist());
  // }, [dispatch]);

  useEffect(() => {
    const loginCart = async () => {
      if (isSignin) {
        const res = await dispatch(postToLoginCart());
        if (res.meta?.requestStatus === "fulfilled") {
        } else if (res.meta?.requestStatus === "rejected") {
          console.log("Error:", res.payload || "Login Cart Post Failed");
        }
      }
      await dispatch(getAllCart(isSignin));
    };

    loginCart();
  }, [dispatch, isSignin]);
  const [email, setEmail] = useState();
  const [contact, setContact] = useState();

  const [searchQuery, setSearchQuery] = useState("");
  const products = ["One", "Two", "Three", "Four", "Five"]; // Example product list

  const navigate = useNavigate();

  const app_setup = useSelector((state) => state.master.app_setup);

  const [showCategory, setShowCategory] = useState(false);

  const [openMega, setOpenMega] = useState(false);
  const [openMegaJewlery, setOpenMegaJewlery] = useState(false);
  const [openMain, setOpenMain] = useState(null);
  const [openSub, setOpenSub] = useState(null);

  const category = useSelector((state) => state.master.categories);
  const subcategories = useSelector((state) => state.master.subcategories);
  const childcategories = useSelector((state) => state.master.childcategories);

  useEffect(() => {
    const handleClickOutside = () => {
      setOpenMega(false);
      setShowCategory(false);
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const productsAll = useSelector(
    (state) => state.product.allProducts?.data || [],
  );

  const handleSubCategoryClick = (
    categoryId,
    subCategoryId,
    subCategoryName,
  ) => {
    setShowServiceMenu(false);
    setShowMobileService(false);

    navigate(
      `/shops?category_id=${categoryId}&sub_category=${encodeURIComponent(
        subCategoryName,
      )}`,
    );

    // navigate(`/shops?sub_category=${encodeURIComponent(subCategoryName)}`);
  };

  useEffect(() => {
    const closeMenu = () => setActiveMenu(null);
    document.addEventListener("click", closeMenu);
    return () => document.removeEventListener("click", closeMenu);
  }, []);

  const handleLinkClick = () => {};

  useEffect(() => {
    dispatch(getHeaderProducts({}));
  }, [dispatch]);

  const [activeMenu, setActiveMenu] = useState(null);

  const callSubCategories = async (cat_id) => {
    await dispatch(getAllSubCategory({ category_id: cat_id }));
  };

  const handleNavigate = (path) => {
    navigate(path);
    setOpenMega(false); // <-- CLOSE ON CLICK
  };

  const [showMenu, setShowMenu] = useState(false);

  const [showServiceMenu, setShowServiceMenu] = useState(false);
  const serviceRef = useRef(null);
  const megaMenuRef = useRef(null);

  const handleNavClose = () => {
    setShowMenu(false);
    setShowServiceMenu(false);
  };

  const handleServiceClick = useCallback(() => {
    if (window.innerWidth > 991) {
      setShowServiceMenu((prev) => !prev);
    } else {
      setShowMobileService(true);
      setShowMenu(false);
    }
  }, []);

  const [showMobileService, setShowMobileService] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (megaMenuRef.current && !megaMenuRef.current.contains(event.target)) {
        handleNavClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const allcategory = useSelector((state) => state.master.categories);
  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);

  return (
    <header className="Header theme_bg_colour custom_header ">
      <div class="top_headers_holder top-view">
        <div class="top_header_marquee">
          {headerData?.map((val, index) => (
            <span key={index}>
              {/* First order ? Get 2% off use code Myease01 *** Get Flat 10% off on
            purchase of Rs 2000 */}
              {val?.name}
            </span>
          ))}
        </div>
      </div>

      <Navbar expand="lg" className="">
        <Container>
          <div className="header_section_holder">
            {/* Mobile Toggle (only visible below lg) */}
            <Navbar.Toggle
              aria-controls="offcanvasNavbar"
              className="d-lg-none me-3 "
              // onClick={handleShow}
              onClick={setShowMobileService}
            />

            {/* Offcanvas for mobile only */}
            <Navbar.Offcanvas
              show={showOffcanvas}
              onHide={handleClose}
              id="offcanvasNavbar"
              aria-labelledby="offcanvasNavbarLabel"
              placement="start"
              className="d-lg-none mobile_view_header_offcanvas"
            >
              <Offcanvas.Header closeButton></Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="main-nav flex-column">
                  <Nav.Link
                    as={Link}
                    onClick={() => {
                      handleClose();
                      handleServiceClick();
                    }}
                  >
                    Our Collection
                  </Nav.Link>
                </Nav>

                <div className="social-icons">
                  {sociallink?.map((val) => (
                    <a
                      href={val?.url}
                      className="social-icon"
                      target="_blank"
                      rel="noopener noreferrer"
                      key={val?.id || val?.url} // Add key if possible
                    >
                      <img
                        src={process.env.REACT_APP_IMG_URL + val?.image}
                        className="social_icon_img"
                        alt="Social icon"
                      />
                    </a>
                  ))}
                </div>
              </Offcanvas.Body>
            </Navbar.Offcanvas>

            <div className="header-icons mobile_view">
              <div
                className="icon-link"
                onClick={() => setShowSearch(!showSearch)}
              >
                <div className="icon_holder">
                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                </div>
              </div>
            </div>

            <div className="desktop_view_logo">
              {/* Logo */}
              <Navbar.Brand as={Link} to="/" className="brand-logo">
                <div className="logo_holder">
                  <img
                    // src="/assets/images/logo/logo.png"
                    src={process.env.REACT_APP_IMG_URL + app_setup?.logo}
                    className="logo_img"
                  />
                </div>
              </Navbar.Brand>
            </div>
          </div>

          {/* Desktop Navigation (visible lg and up) */}
          <div className="d-none d-lg-flex align-items-center justify-content-center w-100">
            <Nav className="main-nav ">
              <Nav.Link
                as={Link}
                to="/"
                className={currentPath === "/" ? "active" : ""}
                onClick={handleNavClose}
              >
                Home
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/about-us"
                className={currentPath === "/about-us" ? "active" : ""}
                onClick={handleNavClose}
              >
                About Us
              </Nav.Link>

              <Nav.Link
                as={Link}
                onClick={handleServiceClick}
                // className={showServiceMenu ? "active" : ""}
              >
                Our Collection
              </Nav.Link>

              <Nav.Link
                as={Link}
                to="/contact-us"
                className={currentPath === "/contact-us" ? "active" : ""}
                onClick={handleNavClose}
              >
                Contact Us
              </Nav.Link>
            </Nav>
          </div>

          <div className="mobile_view_logo">
            {/* Logo */}
            <Navbar.Brand as={Link} to="/" className="brand-logo">
              <div className="logo_holder">
                <img
                  // src="/assets/images/logo/new_ekansi_logo.png"
                  src={process.env.REACT_APP_IMG_URL + app_setup?.logo}
                  className="logo_img"
                />
              </div>
            </Navbar.Brand>
          </div>

          <div className="header_section_holder">
            <div className="header-icons ">
              {/* 🔍 Magnifying Glass Icon */}
              <div
                className="icon-link desktop_view_search"
                onClick={() => setShowSearch(!showSearch)}
              >
                <div className="icon_holder">
                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                </div>
              </div>

              <Link
                to="/wishlist"
                className={`icon-link ${
                  currentPath === "/wishlist" ? "active" : ""
                }`}
              >
                <OverlayTrigger
                  placement="bottom"
                  delay={{ show: 250, hide: 400 }}
                  overlay={renderTooltip("Wishlist")}
                >
                  <div className="icon_holder">
                    <FontAwesomeIcon icon={faHeart} />
                    <Badge className="badge_holder">
                      {allWishlist?.data?.length || 0}
                    </Badge>
                  </div>
                </OverlayTrigger>
              </Link>
              <Link
                to="/product-cart"
                className={`icon-link ${
                  currentPath === "/product-cart" ? "active" : ""
                }`}
              >
                <OverlayTrigger
                  placement="bottom"
                  delay={{ show: 250, hide: 400 }}
                  overlay={renderTooltip("Cart")}
                >
                  <div className="icon_holder">
                    <FontAwesomeIcon icon={faBagShopping} />
                    <Badge className="badge_holder">
                      {allcartData?.data?.length || 0}
                    </Badge>
                  </div>
                </OverlayTrigger>
              </Link>

              {isSignin && (
                <Link
                  to="/account"
                  state={{ tab: "PERSONAL INFORMATION" }}
                  className={`icon-link ${
                    currentPath === "/account" ? "active" : ""
                  }`}
                >
                  <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltip("My Account")}
                  >
                    <FontAwesomeIcon icon={faUser} />
                  </OverlayTrigger>
                </Link>
              )}

              {!isSignin && (
                <div
                  className="icon-link"
                  onClick={() => {
                    setShowLoginModal(true);
                  }}
                >
                  <div className="icon_holder">
                    <FontAwesomeIcon icon={faUser} />
                  </div>
                </div>
              )}
            </div>
          </div>
        </Container>
      </Navbar>
      <Container ref={searchRef}>
        <div className="row justify-content-center">
          <div className="col-md-6 col-12">
            {showSearch && (
              <div className="headsearch">
                <div className="searchdiv">
                  <Form.Control
                    placeholder="Search Product Name / Design ID"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    // onKeyDown={handleKeyPress}
                    autoFocus
                  />
                  <button
                    type="submit"
                    className="searchbtn"
                    // onClick={handleSearchClick}
                  >
                    <FontAwesomeIcon
                      icon={faMagnifyingGlass}
                      className="search_icon"
                    />
                  </button>
                </div>

                {/* Place here */}

                {showSearchResult && (
                  <div className="search_result_dropdown horizontal_search_results">
                    {searchResults?.length > 0 ? (
                      <div className="search_scroll_container">
                        <div className="row g-3">
                          {searchResults?.map((product) => (
                            <div
                              key={product?.id}
                              className="col-6 col-sm-4 col-md-3 col-lg-3"
                            >
                              <div
                                className="search_result_item"
                                onClick={() => {
                                  navigate(`/product-details/${product?.id}`);
                                  closeSearchModal();
                                }}
                              >
                                <div className="search_img_wrapper">
                                  <img
                                    src={product?.image}
                                    alt={product?.name}
                                    className="search_product_img"
                                  />
                                </div>

                                <div className="product_info">
                                  <p>
                                    {product?.name} {"("}
                                    {product?.design_id}
                                    {")"}
                                  </p>

                                  <small>
                                    ₹
                                    {product?.Product_Variants?.[0]?.price || 0}
                                  </small>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <div className="p-3 text-center">No products found</div>
                    )}
                  </div>
                )}

                <div
                  className="close_div"
                  onClick={() => {
                    setShowSearch(!showSearch);
                  }}
                >
                  <FontAwesomeIcon
                    icon={faXmark}
                    className="close_icon"
                    onClick={closeSearchModal}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </Container>

      {/* ------------------------------------------------------------- */}

      <div className="custom_header__bottom">
        <div
          ref={megaMenuRef}
          className={`custom_header__mega_menu ${
            showServiceMenu ? "active" : ""
          }`}
        >
          <Container fluid="md">
            <div className="custom_header__mega_menu_inner">
              {allcategory?.map((service, index) => (
                <div className="custom_header__mega_column" key={index}>
                  <h4 className="custom_header__mega_title">{service?.name}</h4>

                  {service?.isButton ? (
                    <div className="custom_header__share_btn">
                      {/* <Common_Black_Btn
                        btnText={"Share Design"}
                      /> */}
                    </div>
                  ) : (
                    <ul className="custom_header__mega_list">
                      {service?.p_sub_categories?.map((item, itemIndex) => (
                        <div
                          key={itemIndex}
                          className="custom_header__mega_link"
                          // onClick={(e) => {
                          //   e.preventDefault();
                          //   e.stopPropagation();

                          //   handleSubCategoryClick(item?.id, item?.name);
                          // }}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();

                            handleSubCategoryClick(
                              service?.id, // category id
                              item?.id, // sub category id
                              item?.name,
                            );
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <li className="custom_header__mega_item">
                            <span>{item?.name}</span>
                          </li>
                        </div>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          </Container>
        </div>
      </div>

      <Offcanvas
        show={showMobileService}
        onHide={() => setShowMobileService(false)}
        placement="start"
        className="custom_header__service_offcanvas"
      >
        <Offcanvas.Header
          closeButton
          className="custom_header__offcanvas_header"
        >
          <Offcanvas.Title className="custom_header__offcanvas_heading">
            Our Collection
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body className="custom_header__offcanvas_body">
          <Accordion className="mobile_menu_accordion" flush>
            {allcategory?.map((service, index) => (
              <Accordion.Item
                eventKey={String(index)}
                key={service?.id || index}
              >
                <Accordion.Header>{service?.name}</Accordion.Header>

                <Accordion.Body>
                  {service?.isButton ? (
                    <div className="custom_header__share_btn">
                      {/* <Common_Black_Btn btnText={"Share Design"} /> */}
                    </div>
                  ) : (
                    <ul className="custom_header__offcanvas_list">
                      {service?.p_sub_categories?.map((item, itemIndex) => (
                        <li
                          key={item?.id || itemIndex}
                          className="custom_header__mega_item"
                          style={{ cursor: "pointer" }}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();

                            handleSubCategoryClick(
                              service?.id,
                              item?.id,
                              item?.name,
                            );
                          }}
                        >
                          {item?.name}
                        </li>
                      ))}
                    </ul>
                  )}
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>

          <div className="social-icons">
            {sociallink?.map((val) => (
              <a
                key={val?.id || val?.url}
                href={val?.url}
                className="social-icon"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={process.env.REACT_APP_IMG_URL + val?.image}
                  className="social_icon_img"
                  alt="Social icon"
                />
              </a>
            ))}
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Login_Modal
        show={showLoginModal}
        onHide={() => {
          setShowLoginModal(false);
        }}
        setShowResetModal={() => setShowResetModal(true)}
        setShowAccountCreted={() => setShowAccountCreted(true)}
        setShowLogin={() => setShowLogin(true)}
      />

      <Reset_Password_Modal
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        show={showResetModal}
        onHide={() => {
          setShowResetModal(false);
        }}
        setShowSetPassModal={() => setShowSetPassModal(true)}
      />

      <Set_New_Password_Modal
        email={email}
        setEmail={setEmail}
        contact={contact}
        setContact={setContact}
        show={showSetPassModal}
        onHide={() => {
          setShowSetPassModal(false);
        }}
        setShowSucsessModal={() => setShowSucsessModal(true)}
      />

      <Success_Modal
        show={showSuccessModal}
        onHide={() => {
          setShowSucsessModal(false);
        }}
        successText="Password Reseted Successfully!"
      />

      <Success_Modal
        show={showAccountCreted}
        onHide={() => {
          setShowAccountCreted(false);
        }}
        successText="Account Created Successfully!"
      />

      <Success_Modal
        show={showLogin}
        onHide={() => {
          setShowLogin(false);
        }}
        successText="Logged In Successfully!"
      />
    </header>
  );
}

export default Header;
